<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        :min-date="additionals.periodoMinDate"
                        :max-date="additionals.currentDate"
                        v-model="agendamento.periodo"
                        @change="resetFields"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="unidades"
                        label="Unidade executante"
                        show-default-option
                        text-field="unidadeNome"
                        v-model="agendamento.unidadeId"
                        value-field="unidadeId"
                        :validations="validations.unidadeId"
                        @change="resetProfissional"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="profissionais"
                        label="Profissional executante"
                        show-default-option
                        text-field="profissionalNome"
                        v-model="agendamento.profissionalId"
                        value-field="profissionalId"
                        :validations="validations.profissionalId"
                        @change="resetGrupo"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                     <rkm-form-select
                        :options="grupoExames"
                        label="Grupo de exames"
                        show-default-option
                        text-field="grupoExame"
                        v-model="agendamento.grupoExameId"
                        value-field="grupoExameId"
                        :validations="validations.grupoExameId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="exames"
                        label="Exames"
                        show-default-option
                        text-field="exameNome"
                        v-model="agendamento.exameId"
                        value-field="exameId"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        label="Status"
                        textField="nome"
                        v-model="status"
                        valueField="id"
                        show-default-option
                        class="pt-0 mb-0"
                    >
                        <rkm-form-select-option :value="enums.statusFechamento.REALIZADO">
                            REALIZADO
                        </rkm-form-select-option>
                        <rkm-form-select-option :value="enums.statusFechamento.FALTOU">
                            FALTOU
                        </rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.paciente"
                        :search-fields="fields.paciente"
                        :text-field="(item) => item.cidadao.nome"
                        label="Paciente"
                        v-model="paciente"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Número agendamento"
                        v-model="agendamento.agendamentoNumero"
                        number
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Número prontuário"
                        v-model="agendamento.prontuario"
                        number
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(search)"
                        color="primary"
                        class="float-left"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click.stop="resetForm"
                        color="secondary"
                        class="mr-2 float-left"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-table
            v-if="data.model.agendamentosNotSave"
            :fields="fields.tables.agendamento"
            :items="data.model.agendamentosNotSave || data.model.agendamentos"
            ref="Table"
            sort-by="agendamento.data"
            hide-filters
        >
            <template v-slot:cell(status)="{ item }" >
                <rkm-form-select
                    :label="false"
                    textField="nome"
                    v-model="item.statusId"
                    valueField="id"
                    show-default-option
                    class="pt-0 mb-0"
                    @change="loadStatus(item.statusId)"
                >
                    <rkm-form-select-option
                        v-if="item.statusSalvo == enums.statusFechamento.REALIZADO
                            || item.statusSalvo == enums.statusFechamento.AGENDADO"
                        :value="enums.statusFechamento.REALIZADO"
                    >
                        REALIZADO
                    </rkm-form-select-option>
                    <rkm-form-select-option
                        v-if="item.statusSalvo == enums.statusFechamento.FALTOU
                            || item.statusSalvo == enums.statusFechamento.AGENDADO"
                        :value="enums.statusFechamento.FALTOU"

                    >
                        FALTOU
                    </rkm-form-select-option>
                    <rkm-form-select-option
                        :value="enums.statusFechamento.AGENDADO"
                    >
                        AGENDADO
                    </rkm-form-select-option>
                </rkm-form-select>
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    :id="uniqueId('show-btn')"
                    @click="$refs.Modal.open(item)"
                    title="Detalhamento"
                    small
                    color="primary"
                >
                    <rkm-icon icon="search" />
                </rkm-button>
            </template>

            <template v-slot:custom-foot>
                <rkm-tr>
                    <rkm-th colspan="5" class="table-td">Realizado: {{verificaRealizado()}}</rkm-th>
                    <rkm-th colspan="5" class="table-td">Faltou: {{verificaFaltou()}}</rkm-th>
                </rkm-tr>
            </template>
        </rkm-table>

        <Modal
            ref="Modal"
            :data="data"
        />

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Components.
import Modal from '@/components/exame-imagem/fechamento/components/Modal'

// Moment.
import moment from 'moment'

// Enuns.
import statusFechamento from '@/enums/exame-imagem/fechamento/status'

export default {
    components:{ Modal },
    computed: {
        fields() {

            return {
                tables: {
                    agendamento: [
                        { key: 'agendamento.data', label: 'Data do pedido', class: 'col-max', sortable: true },
                        { key: 'agendamento.agendamentoNumero', label: 'Agendamento', class: 'col-max', sortable: true },
                        { key: 'agendamento.prontuario', label: 'Prontuário', class: 'col-max', sortable: true },
                        { key: 'exameNome', label: 'Exame', class: 'col-max', sortable: true },
                        { key: 'agendamento.pacienteNome', label: 'Paciente', class: 'col-max', sortable: true },
                        { key: 'status', label: 'Status', class: 'col-mix', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center'}
                    ]
                },
                paciente: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        validations() {
            return {
                unidadeId: { required: true },
                profissionalId: { required: true },
                grupoExameId: { required: true },
            }
        },
        unidades(){

            let unidadeOrigem = []

            if (this.agendamento.periodo.start && this.agendamento.periodo.end){

                const start = moment(this.agendamento.periodo.start).subtract(1, 'day')
                const end = moment(this.agendamento.periodo.end).add(1, 'day')

                this.data.model.agendamentos.filter(agendamento =>
                    moment(agendamento.agendamento.data, 'DD/MM/YYYY').isBetween(start, end))
                        .map(unidade => {

                            this.resetFields()

                            let verifyUnidade = unidadeOrigem.find(u => u.unidadeId === unidade.agendamento.unidadeId)

                            if(!verifyUnidade){

                                unidadeOrigem.push({

                                    unidadeId: unidade.agendamento.unidadeId,
                                    unidadeNome: unidade.agendamento.unidadeNome
                                })
                            }
                        })
            }

            return unidadeOrigem
        },
        profissionais(){

            let profissionalOrigem = []

            if (this.agendamento.periodo.start && this.agendamento.periodo.end){

                const start = moment(this.agendamento.periodo.start).subtract(1, 'day')
                const end = moment(this.agendamento.periodo.end).add(1, 'day')

                this.data.model.agendamentos.filter(u => moment(u.agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                    && u.unidadeId === this.agendamento.unidadeId)
                        .map(prof => {

                            if (profissionalOrigem){

                                let verifyProfissional = profissionalOrigem.find(u => u.profissionalId === prof.profissionalId)

                                if (!verifyProfissional) {

                                    profissionalOrigem.push({

                                        profissionalId: prof.agendamento.profissionalId,
                                        profissionalNome: prof.agendamento.profissionalNome,
                                    })
                                }
                            }
                        })

                profissionalOrigem.sort((a,b) => (a.profissionalNome > b.profissionalNome) ? 1 : ((b.profissionalNome > a.profissionalNome) ? -1 : 0));
            }

            return profissionalOrigem
        },
        grupoExames(){

            let grupoExameOrigem = []

            if (this.agendamento.periodo.start && this.agendamento.periodo.end){

                const start = moment(this.agendamento.periodo.start).subtract(1, 'day')
                const end = moment(this.agendamento.periodo.end).add(1, 'day')

                this.data.model.agendamentos.filter(g => moment(g.agendamento.data, 'DD/MM/YYYY').isBetween(start, end)
                    && g.unidadeId === this.agendamento.unidadeId
                    && g.profissionalId === this.agendamento.profissionalId)
                        .map(grupo => {

                            if(grupoExameOrigem){

                                let verifyGrupoExame = grupoExameOrigem.find(e => e.grupoExameId === grupo.grupoExameId)

                                if(!verifyGrupoExame){

                                    grupoExameOrigem.push({

                                        grupoExameId: grupo.agendamento.grupoExameId,
                                        grupoExame: grupo.agendamento.grupoExame
                                    })
                                }
                            }
                        })

                grupoExameOrigem.sort((a,b) => (a.grupoExame > b.grupoExame) ? 1 : ((b.grupoExame > a.grupoExame) ? -1 : 0));
            }

            return grupoExameOrigem
        },
        exames(){

            let exameOrigem = []

            if (this.data.model.agendamentos) {

                this.data.model.agendamentos.filter(e => e.unidadeId === this.agendamento.unidadeId
                    && e.profissionalId === this.agendamento.profissionalId
                    && e.grupoExameId === this.agendamento.grupoExameId)
                        .map(exame => {

                            if (exameOrigem) {

                                let verifyExame = exameOrigem.find(u => u.exameId === exame.exameId)

                                if (!verifyExame) {

                                    exameOrigem.push({

                                        exameId: exame.exameId,
                                        exameNome: exame.exameNome,
                                    })
                                }
                            }
                        })

                exameOrigem.sort((a,b) => (a.exameNome > b.exameNome) ? 1 : ((b.exameNome > a.exameNome) ? -1 : 0));
            }

            return exameOrigem
        },
    },
    created() {

        this.repositories = {
            alteracao: this.getConectaSusRepository('exameImagem.alteracaoExameFinalizado'),
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        },
        this.load();
    },
    data() {
        return {
            selecionados: false,
            agendamento: {
                agendamentoId: null,
                agendamentoNumero: null,
                exameId: null,
                grupoExameId: null,
                medicoId: null,
                pacienteId: null,
                nomePaciente: '',
                periodo: {
                    start: null,
                    end: null,
                },
                profissionalId: null,
                prontuario: null,
                statusId: null,
                unidadeId: null,
            },
            realizado: 0,
            faltou: 0,
            enums:{
                statusFechamento,
            },
            dataAtual: '',
            paciente: null,
            status: null,
            handleStatus: null,
            model: {
                periodo: {
                    start: null,
                    end: null,
                },
            },
            additionals: {},
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.alteracao.list()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.dataAtual = data.dataAtual
                    this.additionals = data.additionals

                    this.setDefaultValues()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search(){

            let buscaAgendamento = this.data.model.agendamentos

            if(this.agendamento.agendamentoNumero){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.agendamento.agendamentoNumero == this.agendamento.agendamentoNumero)
            }

            if(this.agendamento.exameId){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.exameId == this.agendamento.exameId)
            }

            if(this.agendamento.grupoExameId){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.agendamento.grupoExameId == this.agendamento.grupoExameId)
            }

            if(this.paciente){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.pacienteId == this.paciente.id)
            }

            if(this.status){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.statusId == this.status)
            }

            if (this.agendamento.periodo.start && this.agendamento.periodo.end){

                const start = moment(this.agendamento.periodo.start).subtract(1, 'day')
                const end = moment(this.agendamento.periodo.end).add(1, 'day')

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    moment(agendamento.agendamento.data, 'DD/MM/YYYY').isBetween(start, end))
            }

            if(this.agendamento.profissionalId){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.agendamento.profissionalId == this.agendamento.profissionalId)
            }

            if(this.agendamento.medicoId){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.agendamento.medicoId == this.agendamento.medicoId)
            }

            if(this.agendamento.prontuario){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.agendamento.prontuario == this.agendamento.prontuario)
            }

            if(this.agendamento.unidadeId){

                buscaAgendamento = buscaAgendamento.filter(agendamento =>
                    agendamento.agendamento.unidadeId == this.agendamento.unidadeId)
            }

            this.data.model.agendamentosNotSave = buscaAgendamento
        },
        resetForm() {

            this.agendamento.agendamentoNumero = null
            this.agendamento.exameId = null
            this.agendamento.grupoExameId = null
            this.agendamento.medicoId = null
            this.paciente = null
            this.status = null
            this.agendamento.profissionalId = null
            this.agendamento.prontuario = null
            this.agendamento.unidadeId = null

            this.data.model.agendamentosNotSave = null

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()
                    this.$refs.Form.resetValidator()
                })
        },
        setDefaultValues() {

            this.agendamento.periodo.start = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.agendamento.periodo.end = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        loadStatus(item){

            this.handleStatus = item
            this.$emit('handleStatusAgendado', this.handleStatus)
        },
        resetFields(){

            this.agendamento.unidadeId = null
            this.agendamento.profissionalId = null
            this.agendamento.grupoExameId = null
            this.agendamento.exameId = null

            this.data.model.agendamentosNotSave = null
        },
        resetMedico(){

            this.agendamento.profissionalId = null
            this.agendamento.grupoExameId = null
            this.agendamento.exameId = null
            this.agendamento.medicoId = null
            this.data.model.agendamentosNotSave = null
        },
        resetProfissional(){

            this.agendamento.profissionalId = null
            this.agendamento.grupoExameId = null
            this.agendamento.exameId = null
            this.data.model.agendamentosNotSave = null
        },
        resetGrupo(){

            this.agendamento.grupoExameId = null
            this.agendamento.exameId = null
            this.data.model.agendamentosNotSave = null
        },
        verificaRealizado(){

            return this.data.model.agendamentosNotSave.filter(item => item.statusId === this.enums.statusFechamento.REALIZADO).length;
        },
        verificaFaltou(){

            return this.data.model.agendamentosNotSave.filter(item => item.statusId === this.enums.statusFechamento.FALTOU).length;
        }
    },
    validate() {

        return this.$refs.Form.validate()
    },
    mixins: [repository, error, object, data, stringCase],
    props: {
        data: { type: Object, required: true }
    },
}
</script>

<style scoped>
    .table-td {
        background: #e6e6e6;
        padding: 0 10px;
        height: 35px;
        border-top: 1px solid #ccc;
        font-weight: 600;
    }
    .table-border-top {
        border-top: 0;
        height: 30px;
        padding: 0;
    }
    .table-width {
        width: 100%;
    }
</style>